export default __webpack_public_path__ + "static/media/add.3d0f95ee.svg";